import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import DiscoveryPage from "pages/DiscoveryPage/DiscoveryPage";
import HomeRoutes from "component/homeRoutes/HomeRoutes";
import { useEffect, useState } from "react";
import AdminSection from "AdminSection/component/AdminSection";
import { ADMIN_ROUTES } from "AdminSection/utils/routesUtils";
import "./App.css";
import { Globalstate } from "context/context";
import { condition } from "context/condition";

function App() {
  const [updateRender, setUpdateRender] = useState(false);
  const { dispatch } = Globalstate();

  useEffect(() => {
    console.log("Deployment: ", "v2");
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const mode = params.get("mode");
    const source = params.get("source");
    // setting source to nudge flow control
    const nudgeFlow = params.get("nf");
    const digiGoldFlow = params.get("dg");
    const token = params.get("param");
    localStorage.setItem("authToken", token);
    if (nudgeFlow === "true") {
      dispatch({ type: condition.SETNUDGEFLOW, payload: true });
    }
    if (digiGoldFlow === "true") {
      dispatch({ type: condition.SETDIGIGOLDFLOW, payload: true });
    }
    dispatch({
      type: condition.SETSOURCE,
      payload: source === "service" ? "service" : "ABCD",
    });
    if (mode === "qna") {
      dispatch({ type: condition.SETMODE, payload: "qna" });
    } else {
      dispatch({ type: condition.SETMODE, payload: "stream" });
    }
  }, [dispatch]);

  return (
    <Router basename={process.env.REACT_APP_BASENAME}>
      <Routes>
        {/* Admin Route */}
        {process.env.REACT_APP_ENV === "uat" && (
          <Route path="/admin" element={<AdminSection />}>
            {ADMIN_ROUTES.map((route, i) => {
              return (
                <Route key={i} path={route.path} element={route.element} />
              );
            })}
          </Route>
        )}
        <Route
          path="/"
          element={
            updateRender ? (
              <HomeRoutes />
            ) : (
              <DiscoveryPage setUpdateRender={setUpdateRender} />
            )
          }
        ></Route>
      </Routes>
    </Router>
  );
}
export default App;
